<template>

  <div class="d-flex justify-content-end align-items-center">
    <button v-if="$can('change-status', 'transaction') && (this.row.status == transactionStatus.FAILED || this.row.status == transactionStatus.UNVERIFIED) " v-on:click="changeStatus" type="button" class="mx-4 btn btn-icon"><i class="fa fa-sync"></i></button>
    <DescriptionColumn
        ref="descriptionColumn"
        @buttonClicked="DescriptionColumn"
        :row="row"
        :index="index"
        :datatable="datatable">
    </DescriptionColumn>
  </div>
</template>

<script>

import Vue from 'vue'
import $ from 'jquery'
import { i18n } from '@/plugins/i18n'
import {transactionService} from "../../../common/api.service";
import toastr from "toastr";
import DescriptionColumn from "./core-description-column.vue";
import {mapGetters} from 'vuex';
import {transactionStatus} from "../../../constants/transactionStatus";

export default Vue.extend({
  components: {DescriptionColumn},
  props: {
    row: {
      required: true,
    },
    index: {
      required: true,
    },
    datatable: {
      required: true,
    }
  },
  data() {
    return {
      data: {},
      loading: false,
      isError: false
    }
  },
  computed: {
      transactionStatus() {
          return transactionStatus
      },
    toastr() {
      toastr.options = {
        closeButton: true,
        positionClass: "toast-bottom-center",
        preventDuplicates: false,
        rtl: false
      }
      return toastr
    },
  },
  methods: {
    changeStatus() {
      if(window.confirm(i18n.t('message.are_you_sure_to_make_this_transaction_success'))){
        transactionService.updateCoreTransactionStatus(this.row.id)
            .then(async ({data}) => {
              await this.datatable.reload()
              this.toastr.success(i18n.t('message.transaction_status_changed_successfully'))
            })
            .catch((error) => {
              this.toastr.error(i18n.t('execption.access_denied'));
        });
      }
    },
    DescriptionColumn() {
      this.$refs.descriptionColumn.appendDataToModal();
    },
  },
  mounted() {
  }
})

</script>